// extracted by mini-css-extract-plugin
module.exports = {"SchoolRow":"ChooseRaceResults_SchoolRow__apNk8","DQNumber":"ChooseRaceResults_DQNumber__1zyNu"};